


























import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({ name: 'TakenIpulseCommentSection' })
export default class TakenIpulseCommentSection extends Vue {
  @Prop()
  surveyProduct!: string

  @Prop()
  surveyUserId!: number

  comment: string = ''

  submit () {
    this.$emit('completeIpulseCommentSection', this.comment)
  }
}
